
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowColour as ObiLightningSnowColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-colour.js';
 
 
 

 
 export const ObiLightningSnowColour = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-colour',
   elementClass: ObiLightningSnowColourElement,
   events: {
     
   }
  });
 
 